module.exports = __webpack_public_path__ + "img/video.c998b0be.png";